(function (appComponents) {

	appComponents.services.quotesBase = function (Components) {

		var quotesBase = {

		};

		quotesBase.name = "quotesBase";

		quotesBase.quotesCollection = [];

		Components.getComponentPrototype().extend(quotesBase);

		quotesBase._cart = quotesBase._getService("cartBase");
		quotesBase._b2bUnit = quotesBase._getService("b2bUnit");
		quotesBase._modals = quotesBase._getService("modals");
		quotesBase._helpers = quotesBase._getService("helpers");


		quotesBase.elements = {
			// get success () {
			// 	return $('[pc-container="modal--success"]');
			// },
		};

		quotesBase.bindings = function () {
			quotesBase._elements.page.on("click", '[pc-container="quotes--add-to-cart"]', function () {
				var quoteCode = $(this).parents('[pc-container="quotes--item"]').attr("pc-value");
				quotesBase.handlers.onAddItem(quoteCode);
			});
			quotesBase._elements.page.on("click", '[pc-container="quotes--convert-to-order"]', function () {
				var quoteCode = $(this).parents('[pc-container="quotes--item"]').attr("pc-value");
				quotesBase.handlers.onConvertQuote(quoteCode);
			});
			quotesBase._elements.page.on("click", '[pc-container="quotes--dl-word"]', function () {
				var quoteCode = $(this).parents('[pc-container="quotes--item"]').attr("pc-value");
				if (!quoteCode) quoteCode = $(this).parents('[pc-container="quote-details--item"]').attr("pc-value");
				quotesBase.handlers.onDownloadWord(quoteCode);
			});
			quotesBase._elements.page.on("click", '[pc-container="quotes--dl-pdf"]', function () {
				var quoteCode = $(this).parents('[pc-container="quotes--item"]').attr("pc-value");
				quotesBase.handlers.onDownloadPdf(quoteCode);
			});
			quotesBase._elements.page.on("click", '[pc-container="quotes--delete"]', function () {
				var quoteCode = $(this).parents('[pc-container="quotes--item"]').attr("pc-value");
				quotesBase.handlers.onDeleteItem(quoteCode);
			});
		};

		quotesBase.search = function (formData) {
			if (formData.customerIndexNo == null || formData.customerIndexNo == "") formData.customerIndexNo = quotesBase._b2bUnit.currentUnit.uid;
			return quotesBase._api.quotes.search(formData).then(function (res) {
				if (res && res.status == 200) {
					quotesBase.decorateQuotes(res.body.results);
					quotesBase.quotesCollection = res.body.results;
					return res.body;
				} else if (res.status == 210) {
					return res.body;
				}
			});
		};

		quotesBase.getQuoteDetails = function (queryData) {
			return quotesBase._api.quotes.getQuote(queryData).then(function (res) {
				if (res && res.status == 200) {
					quotesBase.quotesCollection = [];
					quotesBase.quotesCollection.push(res.body.quoteData);
					return res;
				} else {
					throw res;
				}
			});
		};

		quotesBase.getQuoteByQuoteCode = function (code) {
			var quoteObject = null;
			quotesBase.quotesCollection.forEach(function (quote) {
				if (quote.code == code) {
					quoteObject = quote;
				}
			});
			return quoteObject;
		};

		quotesBase.showDetails = function (code) {
			// quoteObject = quotesBase.getQuoteByQuoteCode(codeOrQuoteObject);

			var paramsData = {
				code: code
			};
			var params = $.param(paramsData);
			var pageData = quotesBase._pages.quoteDetails;

			quotesBase._handlers.onSwitchToPage(pageData, params);

		};

		quotesBase.handlers = {

		};

		quotesBase.decorateQuotes = function (quotes) {
			if (!quotes) return;
			// createdDateAsString expiredDate
			quotes.forEach(function (quote) {
				var divClass;
				var createdDateFormat = moment.unix(quote.created / 1000).format("MM/DD/YYYY");
				var expiredDateUnix = moment.unix(quote.created / 1000).add(1, 'months').unix();
				var expiredDateFormat = moment.unix(expiredDateUnix).format("MM/DD/YYYY");
				var daysLeft = parseInt(moment.duration(expiredDateUnix - (moment.now() / 1000)).asDays() * 1000);
				var daysAgo = quote.quoteValidDays;
				var textClass;

				if (daysAgo < 0) daysAgo = 0;

				if (daysAgo > 25 && daysAgo <= 30) {
					divClass = "o-logo-bg-2";
					textClass = "";
				} else if (daysAgo > 30) {
					textClass = "spcl-quotes";
					daysAgo = "30+";
					divClass = "o-logo-bg-7";
				} else {
					textClass = "spcl-quotes";
					divClass = "o-logo-bg-1";
				}
				var templateData = {
					createdDate: createdDateFormat,
					expiredDate: expiredDateFormat,
					daysLeft: daysLeft,
					daysAgo: daysAgo,
					divClass: divClass,
					textClass: textClass
				};
				quote._templateData = templateData;
			});
		};

		quotesBase.getLastQuotes = function (num) {
			if (!quotesBase._role.flags.isQuotesAllowed) return $.Deferred().resolve();

			var searchDataForLastQuotes = {
				resultsPerPage: num,
				searchTerm: "",
			};
			return quotesBase.search(searchDataForLastQuotes);
		};

		quotesBase.downloadDocumentsRoutine = function (baseUrl, quoteCode) {
			var quote = quotesBase.getQuoteByQuoteCode(quoteCode);
			var isMvMotor = (quote.orderType == "QUOTE_MV_MOTOR") ? true : false;

			var queryObject = {
				orderCode: quoteCode,
				mvMotor: isMvMotor
			};
			var query = $.param(queryObject);
			var url = baseUrl + query;

			quotesBase._helpers.clickAnchorLink(url);

		};

		quotesBase.confirmQuoteCreation = function () {
			return quotesBase._api.quoteCheckout.confirmQuote().then(function (res) {
				if (res && res.status == 200) {
					quotesBase.quotesCollection.push(res.body.orderData);
				}
				return res;
			});
		};

		quotesBase.handlers = {
			onQuoteTitleClick: function (code) {
				quotesBase.showDetails(code);
			},
			onUnitChanged: function () {
				// quotesBase.shouldUpdateLastQuotes = true;
			},
			onAddItem: function (code) {
				quotesBase._cart.addOrderOrQuoteByCode(code);
			},
			onConvertQuote: function (quoteCode) {
				quotesBase._cart.convertQuoteToOrder(quoteCode);
			},
			onDownloadWord: function (quoteCode) {
				// quote/exportworddoc?quoteCode=WEBQ00257001&mvMotor=false
				var baseUrl = quotesBase._url.quotes.downloadAsWord;
				quotesBase.downloadDocumentsRoutine(baseUrl, quoteCode);
			},
			onDownloadPdf: function (quoteCode) {
				var baseUrl = quotesBase._url.quotes.downloadAsPdf;
				quotesBase.downloadDocumentsRoutine(baseUrl, quoteCode);
			},
			onDeleteItem: function (quoteCode) {
				quotesBase._api.quotes.delete(quoteCode).then(function (res) {
					// remove from local collection
					if (res && res.status == 200) {
						quotesBase._events.dispatchEvent("quoteDeleted");
					} else {
						console.log(res);
					}
				});
			}
		};


		quotesBase.init = function () {

			quotesBase._bindings();

			// quotesBase._events.registerHandler("b2bUnitChanged", quotesBase.name, quotesBase.handlers.onUnitChanged);

		};

		return quotesBase;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});